import { useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'constants/index';
import { PermissionType } from 'models';
import { AppService } from 'services';
import { useUserData } from './useUserData';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import ConfigAction from 'redux/actions/configAction';

type MarketplaceKey = 'marketplace';

export type MarketplacePermissions = Record<MarketplaceKey, PermissionType>;

export function useMarketplacePermissions() {
  const [marketplacePermissions, setMarketplacePermissions] = useState<
    MarketplacePermissions
  >();
  const dispatch = useDispatch();
  const { permission } = useSelector((state: RootState) => state.configReducer);
  let dataUser = useUserData();
  dataUser ={...dataUser, uid: dataUser?.uid || dataUser?.user_sys_id};

  const permissionJson = JSON.stringify(permission);
  const marketplacePermissionsJson = JSON.stringify(marketplacePermissions);

  useEffect(() => {
    if(!dataUser?.uid) return;
    (async () => {
      const marketplaceConfig = await AppService.getValueConfigAzure(
        CONFIG.MARKETPLACE.KEY,
        CONFIG.MARKETPLACE.LABEL,
      );
      const parsedData: MarketplacePermissions = marketplaceConfig;
      setMarketplacePermissions(parsedData);
    })();
  }, [dataUser?.uid]);

  useEffect(() => {
    if (!marketplacePermissions || Object.keys(permission).length === 0) return;
    const newPermission = { ...permission, ...marketplacePermissions };
    dispatch(ConfigAction.setPermissionConfigSuccess(newPermission));
  }, [marketplacePermissionsJson, permissionJson]);

  return useMemo(() => permission?.marketplace, [permission?.marketplace]);
}

export default useMarketplacePermissions;
